module.exports = __webpack_public_path__ + "img/GALLERY-ERTIGA-BOOSTER-GREEN-5.ea494210.jpg";